import {
  FilterContext,
  GenericVehicleDetails,
  getUrlFromFilter,
  VehicleContext,
  VehicleContextType,
} from '@finn/ua-vehicle';
import { Breadcrumb } from '@finn/ui-components';
import { useCurrentLocale } from '@finn/ui-utils';
import { useContext, useMemo } from 'react';

export { type Breadcrumb };

type UseProductPageBreadcrumbs = { vehicle?: GenericVehicleDetails };
export const useProductPageBreadcrumbs = ({
  vehicle: vehicleFromProps,
}: UseProductPageBreadcrumbs = {}): Breadcrumb[] => {
  const { vehicle: vehicleFromContext } =
    useContext<VehicleContextType>(VehicleContext);
  const { breadcrumbs: filterBreadcrumbs } = useContext(FilterContext);
  const { locale } = useCurrentLocale();

  const vehicle = vehicleFromContext || vehicleFromProps;

  const breadcrumbs = useMemo(() => {
    if (!vehicle || !vehicle.brand || !vehicle.model) {
      return filterBreadcrumbs as Breadcrumb[];
    }

    const brandUrl = getUrlFromFilter({
      brands: [vehicle.brand.id.toLowerCase()],
    });
    const modelUrl = getUrlFromFilter({
      brands: [vehicle.brand.id.toLowerCase()],
      models: [vehicle.model.toLowerCase()],
    });

    return [
      { title: vehicle.brand.id, url: `/${locale}${brandUrl}` },
      { title: vehicle.model, url: `/${locale}${modelUrl}` },
    ];
  }, [filterBreadcrumbs, vehicle, locale]);

  return breadcrumbs;
};
